module.exports = __webpack_public_path__ + "img/verify.5373d486.svg";